// extracted by mini-css-extract-plugin
export var body = "_k6-0";
export var sectionHeader = "_k6-4";
export var shortcutColumns = "_k6-2";
export var shortcutList = "_k6-1";
export var shortcutSection = "_k6-3";